import { render, staticRenderFns } from "./BrPromptHost.vue?vue&type=template&id=b1292cbc&"
import script from "./BrPromptHost.vue?vue&type=script&lang=js&"
export * from "./BrPromptHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports